export interface Category {
  key: string;
  url: string;
  icon: string;
  image: string;
}

export const categories: Category[] = [
  {
    key: "category.shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    icon: "ri-footprint-line",
    image: "https://readdy.ai/api/search-image?query=Single%20modern%20white%20running%20sneaker%20with%20pastel%20green%20accents%20photographed%20on%20a%20clean%20cream%20studio%20background%2C%20soft%20diffused%20lighting%2C%20minimal%20product%20photography%2C%20crisp%20detail%2C%20airy%20and%20fresh%20composition&width=400&height=300&seq=cat-shoes-1&orientation=landscape",
  },
  {
    key: "category.hoodies",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    icon: "ri-shirt-line",
    image: "https://readdy.ai/api/search-image?query=Folded%20terracotta%20orange%20hoodie%20sweater%20neatly%20displayed%20on%20a%20light%20warm%20beige%20background%2C%20soft%20natural%20studio%20light%2C%20minimal%20aesthetic%20product%20photography%2C%20gentle%20fabric%20texture%2C%20clean%20and%20cozy%20composition&width=400&height=300&seq=cat-hoodies-1&orientation=landscape",
  },
  {
    key: "category.tshirts",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    icon: "ri-t-shirt-line",
    image: "https://readdy.ai/api/search-image?query=Stack%20of%20neatly%20folded%20solid%20color%20cotton%20t-shirts%20in%20muted%20olive%20and%20cream%20tones%20on%20a%20clean%20white%20background%2C%20soft%20studio%20lighting%2C%20minimal%20apparel%20product%20photography%2C%20crisp%20folds%20and%20subtle%20shadows&width=400&height=300&seq=cat-tshirts-1&orientation=landscape",
  },
  {
    key: "category.jackets",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    icon: "ri-t-shirt-air-line",
    image: "https://readdy.ai/api/search-image?query=Stylish%20olive%20green%20bomber%20jacket%20on%20a%20wooden%20hanger%20against%20a%20soft%20cream%20wall%2C%20warm%20natural%20lighting%2C%20minimal%20fashion%20product%20photography%2C%20elegant%20texture%20and%20clean%20composition&width=400&height=300&seq=cat-jackets-1&orientation=landscape",
  },
  {
    key: "category.pants",
    url: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    icon: "ri-t-shirt-2-line",
    image: "https://readdy.ai/api/search-image?query=Pair%20of%20neatly%20folded%20dark%20indigo%20denim%20jeans%20and%20khaki%20chino%20shorts%20on%20a%20light%20beige%20background%2C%20soft%20studio%20light%2C%20minimal%20apparel%20product%20photography%2C%20crisp%20fabric%20detail%20and%20clean%20layout&width=400&height=300&seq=cat-pants-1&orientation=landscape",
  },
  {
    key: "category.headwear",
    url: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    icon: "ri-vip-crown-line",
    image: "https://readdy.ai/api/search-image?query=Minimalist%20beige%20baseball%20cap%20and%20a%20knit%20beanie%20displayed%20on%20a%20clean%20cream%20surface%2C%20soft%20natural%20light%2C%20editorial%20product%20photography%2C%20subtle%20shadows%20and%20fresh%20airy%20composition&width=400&height=300&seq=cat-headwear-1&orientation=landscape",
  },
  {
    key: "category.sets",
    url: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    icon: "ri-layout-grid-line",
    image: "https://readdy.ai/api/search-image?query=Coordinated%20matching%20tracksuit%20set%20in%20soft%20sage%20green%20laid%20flat%20on%20a%20warm%20white%20background%2C%20soft%20studio%20lighting%2C%20minimal%20fashion%20flat%20lay%2C%20clean%20lines%20and%20gentle%20shadows&width=400&height=300&seq=cat-sets-1&orientation=landscape",
  },
  {
    key: "category.underwear",
    url: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    icon: "ri-archive-line",
    image: "https://readdy.ai/api/search-image?query=Neatly%20folded%20cotton%20underwear%20basics%20in%20soft%20neutral%20tones%20arranged%20on%20a%20clean%20light%20background%2C%20gentle%20studio%20lighting%2C%20minimal%20apparel%20product%20photography%2C%20tidy%20and%20fresh%20composition&width=400&height=300&seq=cat-underwear-1&orientation=landscape",
  },
  {
    key: "category.jersey",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    icon: "ri-trophy-line",
    image: "https://readdy.ai/api/search-image?query=Professional%20sports%20jersey%20with%20bold%20red%20and%20white%20striped%20design%20displayed%20flat%20on%20a%20clean%20white%20background%2C%20bright%20studio%20lighting%2C%20crisp%20fabric%20detail%2C%20energetic%20yet%20clean%20product%20photography&width=400&height=300&seq=cat-jersey-1&orientation=landscape",
  },
  {
    key: "category.accessories",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    icon: "ri-vip-diamond-line",
    image: "https://readdy.ai/api/search-image?query=Collection%20of%20fashion%20accessories%20including%20sunglasses%2C%20a%20wristwatch%20and%20a%20bracelet%20arranged%20on%20a%20warm%20beige%20background%2C%20soft%20natural%20light%2C%20minimal%20editorial%20product%20photography%2C%20elegant%20and%20airy%20composition&width=400&height=300&seq=cat-accessories-1&orientation=landscape",
  },
  {
    key: "category.bags",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    icon: "ri-handbag-line",
    image: "https://readdy.ai/api/search-image?query=Stylish%20tan%20leather%20crossbody%20bag%20and%20a%20minimalist%20canvas%20backpack%20on%20a%20clean%20cream%20background%2C%20soft%20studio%20lighting%2C%20premium%20product%20photography%2C%20rich%20texture%20and%20clean%20composition&width=400&height=300&seq=cat-bags-1&orientation=landscape",
  },
  {
    key: "category.belts",
    url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    icon: "ri-links-line",
    image: "https://readdy.ai/api/search-image?query=Rolled%20brown%20and%20black%20leather%20belts%20with%20metal%20buckles%20arranged%20elegantly%20on%20a%20light%20neutral%20background%2C%20soft%20studio%20light%2C%20minimal%20accessory%20product%20photography%2C%20refined%20detail%20and%20clean%20layout&width=400&height=300&seq=cat-belts-1&orientation=landscape",
  },
  {
    key: "category.perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    icon: "ri-flask-line",
    image: "https://readdy.ai/api/search-image?query=Elegant%20amber%20glass%20perfume%20bottle%20with%20a%20gold%20cap%20on%20a%20soft%20cream%20background%2C%20warm%20studio%20lighting%2C%20luxury%20product%20photography%2C%20subtle%20reflection%20and%20sophisticated%20composition&width=400&height=300&seq=cat-perfumes-1&orientation=landscape",
  },
  {
    key: "category.other",
    url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    icon: "ri-stack-line",
    image: "https://readdy.ai/api/search-image?query=Assorted%20lifestyle%20items%20including%20a%20keychain%2C%20socks%20and%20a%20small%20pouch%20arranged%20on%20a%20clean%20light%20background%2C%20soft%20natural%20lighting%2C%20minimal%20product%20photography%2C%20tidy%20and%20fresh%20composition&width=400&height=300&seq=cat-other-1&orientation=landscape",
  },
];

export const mainWebsiteUrl = "https://kaspreadsheet.com";